var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'video-chat',
    {
      'video-chat-with-users': _vm.totaluser > 1,
      'video-chat-grid': _vm.totaluser > 2
    }
  ]},[_c('webrtc-video',{ref:"webrtc",attrs:{"width":"100%","room-id":_vm.roomId,"socket-u-r-l":_vm.socketURL,"user-name":_vm.userName,"users":_vm.users},on:{"joined-room":_vm.onJoinRoom,"left-room":_vm.onLeftRoom,"toggle-mute":_vm.handleToggleMute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }